import React from 'react';

const AuditIcon = ({ fill }) => {
  return (
    <svg
      viewBox="2.5 2 21 21"
      width="16"
      height="16"
      fill="none"
      stroke={fill}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M12 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v4" />
      <circle cx="16.5" cy="17.5" r="2.5" />
      <path d="M18.5 19.5l2.5 2.5" />
    </svg>
  );
};

export default AuditIcon;
